import { z } from 'zod';

export const CuratorWishlistPlatformSchema = z
  .enum(['MUSINSA', '29CM'])
  .describe('CuratorWishlistPlatformSchema');

export type CuratorWishlistPlatform = z.infer<typeof CuratorWishlistPlatformSchema>;
